module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLEj6Z11lFd2JQEl8qw.e9fd398a.woff2";